export const TypeResult = [
  { name: 'OverallResult', value: 'Overall' },
  { name: 'AnnualResult', value: 'yearly'},
  { name: 'MonthlyResult', value: 'monthly' },
  { name: 'WeeklyResult', value: 'weekly' },
  { name: 'DailyResult', value: 'daily' },
]
